import React, { useState } from 'react';
import { Calendar, Clock, MapPin, Users, Play, ChevronDown, CheckCircle, Menu, X, Facebook, Instagram, Youtube, BookOpen, Heart, Award, Coffee, Info, Church } from 'lucide-react';

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // --- DADOS DA PROGRAMAÇÃO (Baseados no PDF Oficial) ---
  const scheduleData = [
    {
      day: "Dia 10/02 - Terça-feira (Manhã)",
      location: "Escola Joselma Lima de Souza",
      events: [
        { time: "07:30", title: "Credenciamento e Coffee Break", description: "Recepção dos participantes", type: "social", icon: <Coffee size={20} /> },
        { time: "08:40", title: "Momento Espiritual", type: "holy", icon: <Church size={20} /> },
        { time: "08:50", title: "Momento Cívico", type: "main", icon: <Award size={20} /> },
        { time: "09:00", title: "Momento Cultural", description: "Daniel Lins e Anthony Costta Zabilini", type: "art", icon: <Users size={20} /> },
        { time: "09:30", title: "Pronunciamento das Autoridades", type: "main", icon: <Users size={20} /> },
        { time: "09:50", title: "Palestra Magna 1", speaker: "Psic. Ma. Marcelle Grécia & Dilma Roselli (TJRR)", description: "Tema: Saúde Mental e Bem-Estar Socioemocional dos Profissionais da Educação.", type: "lecture", icon: <Heart size={20} /> },
        { time: "10:35", title: "Interação com o Público", type: "interaction", icon: <Users size={20} /> },
        { time: "10:55", title: "Informes para a tarde", description: "Prof. Aline Luanda e Equipe PME.", type: "info", icon: <Info size={20} /> },
        { time: "11:00", title: "Encerramento Manhã", type: "break", icon: <Clock size={20} /> },
      ]
    },
    {
      day: "Dia 10/02 - Terça-feira (Tarde)",
      location: "Escola Joselma Lima de Souza",
      events: [
        { time: "14:00", title: "Oficinas Temáticas (Simultâneas)", description: "1. BNCC da Computação (CEFORR) | 2. IA na Educação | 3. Jogos de Mesa.", type: "workshop", icon: <BookOpen size={20} /> },
        { time: "16:05", title: "Coffee Break", type: "social", icon: <Coffee size={20} /> },
        { time: "17:30", title: "Encerramento do Dia", type: "break", icon: <Clock size={20} /> },
      ]
    },
    {
      day: "Dia 11/02 - Quarta-feira (Manhã)",
      location: "Escola Joselma Lima de Souza",
      events: [
        { time: "07:30", title: "Coffee Break de Boas-vindas", type: "social", icon: <Coffee size={20} /> },
        { time: "08:00", title: "Momento Espiritual", type: "main", icon: <Heart size={20} /> },
        { time: "08:10", title: "Retrospectiva 2025", type: "main", icon: <Award size={20} /> },
        { time: "08:30", title: "Momento Cultural", description: "Matheus Mendes e Anthony Costta Zabilini", type: "art", icon: <Users size={20} /> },
        { time: "09:00", title: "Palestra 2: Recomposição de Aprendizagem", speaker: "Prof. Dr. Maria Leorgete Joca da Costa (UFRR)", type: "lecture", icon: <BookOpen size={20} /> },
        { time: "10:00", title: "Palestra 3: Leitura e Escrita na Ed. Infantil", speaker: "Prof. Dr. Leuda Evangelista de Oliveira (UFRR)", type: "lecture", icon: <BookOpen size={20} /> },
        { time: "11:00", title: "Informes / Encerramento Manhã", type: "break", icon: <Clock size={20} /> },
      ]
    },
    {
      day: "Dia 11/02 - Quarta-feira (Tarde)",
      location: "Escola Joselma Lima de Souza",
      events: [
        { time: "14:00", title: "Palestra 4: Inclusão e Equidade", speaker: "Prof. Esp. Josélia Grudtner & Psic. Stiven Max", description: "Estratégias para uma educação inclusiva.", type: "lecture", icon: <Users size={20} /> },
        { time: "15:00", title: "Coffee Break", type: "social", icon: <Coffee size={20} /> },
        { time: "15:30", title: "Palestra 5: Ética, Responsabilidade e Direitos Humanos", speaker: "Marcelly Saldanha", description: "Tema: Ética, Responsabilidade e Direitos Humanos na Atuação dos Agentes Públicos da Educação.", type: "lecture", icon: <Award size={20} /> },
      ]
    }
  ];

  // --- DADOS DOS PALESTRANTES (Nomes Completos Baseado no PDF) ---
  const speakers = [
    { 
      name: "Psic. Ma. Marcelle Grécia & Dilma Roselli", 
      role: "Tribunal de Justiça de Roraima (TJRR)", 
      topic: "Saúde Mental e Bem-Estar Socioemocional",
      img: "/marcelle.jpg" 
    },
    { 
      name: "Prof. Dr. Maria Leorgete Joca da Costa", 
      role: "Universidade Federal de Roraima (UFRR)", 
      topic: "Recomposição de Aprendizagem",
      img: "/leorgete.jpg" 
    },
    { 
      name: "Prof. Dr. Leuda Evangelista de Oliveira", 
      role: "Universidade Federal de Roraima (UFRR)", 
      topic: "Leitura e Escrita na Educação Infantil",
      img: "/leuda.jpg" 
    },
    { 
      name: "Prof. Esp. Josélia Grudtner", 
      role: "SEMED Rorainópolis", 
      topic: "Inclusão e Equidade",
      img: "/joselia.jpg" 
    },
    { 
      name: "Psic. Esp. Stiven Max Jesus Almeida", 
      role: "Especialista em Inclusão", 
      topic: "Inclusão e Equidade",
      img: "/stiven.jpg" 

    },
    {
      name: "Marcelly Saldanha", 
      role: "Mestranda em Direitos Humanos (UERR)", 
      topic: "Ética, Responsabilidade e Direitos Humanos na Atuação dos Agentes Públicos",
      img: "/marcelly.jpg" 
    }
  ];

  // Função para evitar erro se a imagem não existir
  const handleImageError = (e) => {
    e.target.src = "https://via.placeholder.com/400?text=Foto+Indisponível";
  };

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-gray-800">
      
      {/* --- NAVBAR --- */}
      <nav className="bg-white shadow-md sticky top-0 z-50 border-b-4 border-yellow-400">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex flex-col leading-tight">
            <span className="text-xs font-bold text-gray-500 uppercase tracking-widest">Prefeitura de</span>
            <div className="flex items-center gap-2">
              <span className="text-2xl font-black text-blue-900">RORAINÓPOLIS</span>
            </div>
          </div>
          
          {/* Menu Desktop */}
          <div className="hidden md:flex space-x-8 font-medium text-gray-700">
            <a href="#inicio" className="hover:text-blue-600 transition">Início</a>
            <a href="#programacao" className="hover:text-blue-600 transition">Agenda</a>
            <a href="#palestrantes" className="hover:text-blue-600 transition">Palestrantes</a>
            <a href="#inscricao" className="px-5 py-2 bg-blue-900 text-white rounded-full hover:bg-blue-800 transition shadow-md">Inscreva-se</a>
          </div>

          {/* Menu Mobile Button */}
          <button className="md:hidden text-blue-900" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Menu Mobile Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t p-4 flex flex-col space-y-4 shadow-lg">
            <a href="#inicio" onClick={() => setIsMenuOpen(false)}>Início</a>
            <a href="#programacao" onClick={() => setIsMenuOpen(false)}>Agenda</a>
            <a href="#palestrantes" onClick={() => setIsMenuOpen(false)}>Palestrantes</a>
            <a href="#inscricao" className="text-blue-900 font-bold" onClick={() => setIsMenuOpen(false)}>Inscreva-se</a>
          </div>
        )}
      </nav>

      {/* --- HERO SECTION (CABEÇALHO COM VÍDEO) --- */}
      <header id="inicio" className="relative bg-blue-900 text-white overflow-hidden">
        {/* Pattern de fundo */}
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-yellow-400 via-blue-900 to-blue-950"></div>
        
        <div className="container mx-auto px-4 py-16 md:py-24 relative z-10 grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Texto de Apresentação */}
          <div className="space-y-6 animate-fade-in-up text-center lg:text-left">
            <span className="inline-block bg-yellow-400 text-blue-900 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider shadow-md">
              10 e 11 de Fevereiro de 2026
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight">
              Jornada Pedagógica <br/>
              <span className="text-yellow-400">Rorainópolis 2026</span>
            </h1>
            <div className="bg-white/10 p-8 rounded-xl border-l-4 border-yellow-400 backdrop-blur-sm">
              <p className="text-lg md:text-xl text-blue-100 italic font-medium">
                "Educar com Empatia: Cuidar de Si, do Outro e do Mundo"
              </p>
              
              <a 
            href="https://forms.gle/14ULVV6EpmKH68WT6" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-yellow-400 text-blue-900 text-lg font-bold py-4 px-10 rounded-full hover:bg-yellow-300 transition shadow-xl transform hover:scale-90"
          >
            Fazer Inscrição Agora
          </a>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-center lg:justify-start">
              <a href="#programacao" className="bg-yellow-400 text-blue-900 font-bold py-3 px-8 rounded-full hover:bg-yellow-300 transition shadow-lg text-center transform hover:-translate-y-1">
                Ver Programação
              </a>
              <a href="#local" className="border-2 border-white text-white font-bold py-3 px-8 rounded-full hover:bg-white hover:text-blue-900 transition text-center flex items-center justify-center gap-2">
                <MapPin size={20} /> Escola Joselma Lima
              </a>
            </div>
          </div>

          {/* ÁREA DO VÍDEO ANIMADO DA LOGO */}
          <div className="flex justify-center items-center">
            <div className="relative w-full max-w-lg aspect-video bg-black rounded-2xl shadow-2xl border-4 border-blue-400/30 overflow-hidden group">
              
              {/* --- INSTRUÇÃO: Substitua este bloco pelo seu vídeo --- */}
              {/* Para ativar o vídeo, descomente as linhas abaixo e garanta que o arquivo 'video-logo-joranda.mp4' esteja na pasta public */}
               <video autoPlay loop muted playsInline className="w-full h-full object-cover">
                 <source src="/video-logo-joranda.mp4" type="video/mp4" />
              </video> 


            </div>
          </div>
        </div>
        
        {/* Divisor de onda (SVG) */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M0 30L60 35C120 40 240 50 360 55C480 60 600 60 720 50C840 40 960 20 1080 15C1200 10 1320 20 1380 25L1440 30V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V30Z" fill="#F8FAFC"/>
          </svg>
        </div>
      </header>

      {/* --- PROGRAMAÇÃO --- */}
      <section id="programacao" className="py-20 container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-blue-600 font-bold uppercase tracking-wider text-sm">Agenda Oficial</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2">Programação Completa</h2>
          <div className="w-24 h-1 bg-yellow-400 mx-auto rounded-full mt-4"></div>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Acompanhe as atividades dos dias 10 e 11 de Fevereiro.
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-8">
          {scheduleData.map((dayData, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden border-l-8 border-yellow-400 hover:shadow-xl transition duration-300">
              <div className="bg-blue-900 text-white py-4 px-6 flex flex-col sm:flex-row justify-between items-center gap-3">
                <div className="font-bold text-xl flex items-center gap-2">
                  <Calendar className="w-6 h-6 text-yellow-400" />
                  {dayData.day}
                </div>
                <div className="text-sm bg-blue-800 px-3 py-1 rounded-full flex items-center gap-1 border border-blue-700">
                  <MapPin size={14} className="text-yellow-400" /> {dayData.location}
                </div>
              </div>
              <div className="divide-y divide-gray-100 p-2 md:p-4">
                {dayData.events.map((event, idx) => (
                  <div key={idx} className="p-4 hover:bg-blue-50 transition duration-200 rounded-lg flex flex-col md:flex-row gap-4 md:items-start group">
                    <div className="flex items-center gap-2 md:w-28 flex-shrink-0 text-blue-900 font-bold bg-blue-100 md:bg-transparent px-3 py-1 md:p-0 rounded-full w-fit text-sm md:text-base">
                      <Clock size={16} />
                      {event.time}
                    </div>
                    <div className="flex-grow">
                      <h4 className="text-lg font-bold text-gray-800 group-hover:text-blue-800 transition">
                        {event.title}
                      </h4>
                      {event.description && <p className="text-gray-600 mt-1 text-sm">{event.description}</p>}
                      {event.speaker && (
                        <div className="mt-2 inline-flex items-center gap-2 text-xs font-semibold text-blue-600 bg-white border border-blue-100 px-3 py-1 rounded-full shadow-sm">
                          <Users size={14} />
                          <span>{event.speaker}</span>
                        </div>
                      )}
                    </div>
                    <div className="hidden md:block text-gray-300 group-hover:text-blue-300 transition">
                      {event.icon}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
            <p className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded max-w-2xl mx-auto shadow-sm">
                <strong>Nota:</strong> Os dias 12, 13, 19 e 20 de fevereiro serão destinados ao planejamento pedagógico interno nas escolas.
            </p>
        </div>
      </section>

      {/* --- PALESTRANTES --- */}
      <section id="palestrantes" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">Nossos Palestrantes</h2>
            <div className="w-24 h-1 bg-yellow-400 mx-auto rounded-full"></div>
            <p className="mt-4 text-gray-600">Conheça os especialistas convidados.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {speakers.map((speaker, index) => (
              <div key={index} className="group relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col overflow-hidden border border-gray-100">
                {/* Área da Foto */}
                <div className="h-64 bg-gray-200 overflow-hidden relative">
                  <img 
                    src={speaker.img} 
                    alt={speaker.name} 
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition duration-500"
                    onError={handleImageError}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900 to-transparent opacity-50 group-hover:opacity-30 transition"></div>
                  <div className="absolute bottom-3 left-3">
                     <span className="bg-yellow-400 text-blue-900 text-xs font-bold px-2 py-1 rounded uppercase tracking-wide">Palestrante</span>
                  </div>
                </div>
                
                <div className="p-6 flex-grow flex flex-col">
                  <h3 className="text-xl font-bold text-gray-900 leading-tight">{speaker.name}</h3>
                  <p className="text-blue-600 font-medium text-sm mt-1 mb-4">{speaker.role}</p>
                  
                  <div className="mt-auto pt-4 border-t border-gray-100">
                    <p className="text-gray-500 text-xs uppercase font-bold mb-1">Tema da Palestra</p>
                    <p className="text-gray-700 text-sm">{speaker.topic}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- CTA / INSCRIÇÃO --- */}
      <section id="inscricao" className="py-16 bg-blue-900 text-white text-center px-4 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-yellow-400 opacity-10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl"></div>
        
        <div className="relative z-10 max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold mb-6">Participe da Transformação da Educação</h2>
          <p className="text-blue-100 mb-8 text-lg">
            "Educar com Empatia" é o nosso compromisso. Garanta sua vaga, receba seu material e certificado de participação.
          </p>
          <a 
            href="https://forms.gle/14ULVV6EpmKH68WT6" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-yellow-400 text-blue-900 text-lg font-bold py-4 px-10 rounded-full hover:bg-yellow-300 transition shadow-xl transform hover:scale-105"
          >
            Fazer Inscrição Agora
          </a>
        </div>
      </section>

      {/* --- RODAPÉ --- */}
      <footer className="bg-gray-900 text-gray-300 py-12 border-t-8 border-yellow-400">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-10 mb-12">
            
            {/* Logo da Jornada (Texto) */}
            <div className="text-center lg:text-left">
              <h4 className="text-2xl font-bold text-white mb-2">Jornada Pedagógica 2026</h4>
              <p className="text-sm text-gray-400 max-w-md">
                Promovendo formação continuada que inspira práticas pedagógicas humanizadas.
              </p>
              <div className="flex gap-4 mt-6 justify-center lg:justify-start">
                <a href="https://www.instagram.com/semed.rorainopolis/
                " className="hover:text-yellow-400 transition"><Instagram size={24} /></a>
                <a href="#" className="hover:text-yellow-400 transition"><Facebook size={24} /></a>
                <a href="#" className="hover:text-yellow-400 transition"><Youtube size={24} /></a>
              </div>
            </div>

            {/* ÁREA DE LOGOS (SEMED E PREFEITURA) */}
            <div className="flex flex-col sm:flex-row items-center gap-8 bg-gray-800/50 p-8 rounded-2xl border border-gray-700">
              
              {/* Espaço Logo SEMED */}
              <div className="text-center">
                <p className="text-[10px] text-gray-500 mb-2 uppercase tracking-widest font-bold">Realização</p>
                <div className="h-20 w-48 bg-white rounded flex items-center justify-center px-4 overflow-hidden">
                  {/* Substitua o src abaixo por "/logo-semed.png" */}
                  <img 
                    src="/logo-semed.png" 
                    alt="Logo SEMED" 
                    className="max-h-16 max-w-full"
                    onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentNode.innerHTML = '<span class="text-gray-800 font-bold text-xs">LOGO SEMED</span>';
                    }}
                  />
                </div>
              </div>

              <div className="hidden sm:block h-16 w-px bg-gray-600"></div>

              {/* Espaço Logo Prefeitura */}
              <div className="text-center">
                <p className="text-[10px] text-gray-500 mb-2 uppercase tracking-widest font-bold">Apoio</p>
                <div className="h-20 w-48 bg-white rounded flex items-center justify-center px-4 overflow-hidden">
                  {/* Substitua o src abaixo por "/logo-prefeitura.png" */}
                  <img 
                    src="/logo-prefeitura.png" 
                    alt="Logo Prefeitura" 
                    className="max-h-36 max-w-full"
                    onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentNode.innerHTML = '<span class="text-gray-800 font-bold text-xs">LOGO PREFEITURA</span>';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center text-sm">
            <p>&copy; 2026 Prefeitura Municipal de Rorainópolis. Secretaria Municipal de Educação.</p>
            <p className="mt-2 text-gray-600">Alessandro Daltro (Prefeito) | Athila Bessa (Vice-prefeito) | Murielly Neves (Secretária municipal de educação)
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;